import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "professionals",
    object: "professional",
    header: [
      { text: "Nombres", value: "first_name" },
      { text: "Apellidos", value: "last_name" },
      { text: "Foto de Perfil", value: "profile_picture", sortable: false  },
      { text: "Tiene Mercado Pago", value: "mp_token", sortable: false  },
      { text: "Dias disponibles", value: "availability_day", sortable: false  },
      { text: "Reviews", value: "review" },
      { text: "Acciones", value: "actions", sortable: false }
    ],
    types: [{ id: "professional", name: "Profesional" }],
    options: {
      sortBy: ["_id"],
      sortDesc: [true]
    }
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions,
    getRoles({ commit }) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + "roles")
          .then(response => {
            commit("success", { roles: response.data });
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    }
  },
  getters: {
    ...genericStore.getters
  }
};
